export enum Schema {
    platform = 'platform',
    atb = 'atb',
    pusk = 'pusk',
    portal = 'portal',
}

export function checkSchemaName(schemaName: string | null | undefined): Schema | undefined {
    if (!schemaName || !(schemaName in Schema)) return undefined;
    return schemaName as Schema;
}

export function parseTableRef(ref?: string) {
    let tableName: string | undefined, schemaName: string | undefined | null;
    if (ref) {
        if (ref.indexOf('.') !== -1) [schemaName, tableName] = ref.split('.', 2);
        else tableName = ref;
        if (schemaName && schemaName in Schema === false) {
            schemaName = null;
        }
    }
    return { schemaName, tableName } as {
        schemaName: keyof typeof Schema | undefined | null;
        tableName: string | undefined;
    };
}
